module.exports = __webpack_public_path__ + "img/Budget.3b611977.svg";